import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable, take } from 'rxjs';

import { EnvUtils } from '@ecm/dispatcher';
import { ContextService } from '@ecm/portfolio';

@Component({
    selector: 'ecm-service-header',
    templateUrl: 'service-header.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceHeaderComponent implements OnInit {
    /**
     * Is authenticated or not to show visitor menu or authenticated menu
     */
    public isAuthenticated$: Observable<boolean>;

    protected isEclair = false;

    @Input()
    public isSoshMenu: boolean;

    public constructor(private readonly contextService: ContextService) {}

    public ngOnInit() {
        this.isAuthenticated$ = this.contextService.isAuthenticated().pipe(take(1));
        this.isEclair = EnvUtils.isEclair();
    }
}
